<template>
  <div class="library">
    <Library />
  </div>
</template>

<script>
// @ is an alias to /src
import Library from '@/components/Library.vue'

export default {
  name: 'library',
  components: {
    Library
  }
}
</script>
